import { render } from "./ExpertStatisticsOriginDetail.vue?vue&type=template&id=53c49ea1"
import script from "./ExpertStatisticsOriginDetail.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsOriginDetail.vue?vue&type=script&lang=js"

import "./ExpertStatisticsOriginDetail.vue?vue&type=style&index=0&id=53c49ea1&lang=css"
script.render = render

export default script